import React from "react";
// import EditProfileContainer from '../../../../Components/Applications/Users/UsersEdit'
// import SettingsContainer from "../../Components/settings";
// import TrailRequestLists from "../../../../Components/settings/Company/TrailRequest/Table";
import APIContainer from "../../../../Components/settings/Company/TrailRequest";
export default function TrailRequests() {
    return (
        <div className="page-body">
            <APIContainer />
        </div>
    );
}
